export default {
  counterPlace: {
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    step4: "Step 4",
    addTitle: "Add a Counter",
    residenceZone: "Residence Zone",
    villageQuarter: "Village / Quarter",
    chooseVillage: "Choose a Village",
    gpsPosition: "GPS Position",
    latitude: "Latitude",
    longitude: "Longitude",
    counterNumber: "Counter Number",
    twoWireCounters: "Two-Wire Counters",
    fourWireCounters: "Four-Wire Counters",
    electricityAvailable: "Electricity Available",
    heavyEquipmentAvailable: "Heavy Equipment Available",
    subscriberType: "Subscriber Type",
    chooseSubscriberType: "Choose Subscriber Type",
    companyName: "Company Name",
    surveyorName: "Surveyor Name",
    deleteTitle: "Delete Counter Place",
  },
  place: {
    breakerTypeWished: "Desired breaker type",
    add: "Add",
    number: "Counter slot N°{num}",
    villageNeighborhood: "Village / Neighborhood",
    surveyor: "Surveyor",
    surveyDate: "Survey date",
    subscriberType: "Subscriber type",
    businessName: "Company name",
    detail1: "Detail 1",
    detail2: "Detail 2",
    other: "Other",
    companyWorks: "Construction company",
    workZone: "Work zone",
    agency: "SBEE agency",
    eligible: "Eligible",
    solded: "Paid",
    latitude: "Latitude",
    longitude: "Longitude",
    nbCounters2filsWished: "Desired 2-wire counters",
    nbCounters4filsWished: "Desired 4-wire counters",
    circuitBreakerType: "Desired breaker type",
    availableElectricSystem: "Available electrical system",
    heavyEquip: "Planned heavy equipment",
    comment: "Comment",
    changeEligibility: "Change eligibility",
    countersList: "Counters list",
    viewMap: "View on map",
    none: "No counter slot",
    editTitle: "Modifier une place compteur",
    nb2wires: "Nombre de compteurs 2 fils",
    nb4wires: "Nombre de compteurs 4 fils",
    selectCompany: "Sélectionner une entreprise",
    company: "Entreprise",
    selectBreakerType: "Sélectionner un type de disjoncteur",
    editTitle: "Edit place counter",
    nb2wires: "Number of 2-wire meters",
    nb4wires: "Number of 4-wire meters",
    selectCompany: "Select a company",
    company: "Company",
    selectBreakerType: "Select breaker type"
  }
};
